import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Header.css';

function Header() {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [username, setUsername] = useState('');
    const [userRole, setUserRole] = useState('');
    const navigate = useNavigate();

    const decodeJWT = (token) => {
        try {
            const base64Url = token.split('.')[1];
            const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));
            return JSON.parse(jsonPayload);
        } catch (error) {
            console.error('Error decoding JWT:', error);
            return null;
        }
    };

    useEffect(() => {
        const token = localStorage.getItem('authToken');
        const storedUsername = localStorage.getItem('username');

        if (token) {
            setIsLoggedIn(true);
            setUsername(storedUsername || 'User');
            const decoded = decodeJWT(token);
            if (decoded && decoded.role) {
                setUserRole(decoded.role);
            }
        }
    }, []);

    const handleLogout = () => {
        localStorage.removeItem('authToken');
        localStorage.removeItem('username');
        localStorage.removeItem('userId');
        setIsLoggedIn(false);
        setUsername('');
        setUserRole('');
        navigate('/login');
    };

    return (
        <header className="header">
            <nav className="nav">
                <ul className="nav-left">
                    <li><a href="/events">Üritused</a></li>
                    <li><a href="/chat">Vestlus</a></li>
                    {isLoggedIn && userRole === 'admin' && <li><a href="/events/create">Loo üritus</a></li>}
                    {isLoggedIn && userRole === 'admin' && <li><a href="/admin">Haldus</a></li>}
                </ul>
                <ul className="nav-right">
                    {!isLoggedIn ? (
                        <>
                            <li className="auth-item"><a href="/login">Logi sisse</a></li>
                            <li className="auth-item"><a href="/register">Registreeri</a></li>
                        </>
                    ) : (
                        <>
                            <li className="auth-item"><a href="/profile">Profiil</a></li>
                            <li className="user-info">
                                <span className="welcome-text">Tere tulemast,</span>
                                <span className="username-text">{username}!</span>
                            </li>
                            <li className="auth-item">
                                <button onClick={handleLogout} className="logout-btn">
                                    Logi välja
                                </button>
                            </li>
                        </>
                    )}
                </ul>
            </nav>
        </header>
    );
}

export default Header;